module.exports = __webpack_public_path__ + "img/1602cep.6b7aba29.svg";